import React from 'react';
import { observer } from 'mobx-react';
import { Text, Box, Flex } from 'core/components';
import { ResultMenuItemSingleRow } from './ResultMenuItem';
import { handleJourneyAction } from '../SearchResults';
import styled, { css } from 'styled-components';
import { lighten } from 'polished';

const JourneyResultContainer = styled(Box)`
  background-color: #000;
  border-radius: 16px 16px 0px;
  padding: 12px;
  z-index: 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    border-radius: inherit;
    background: linear-gradient(270deg, #00c6ff, #0072ff, #b721ff, #fdbb2d);
    margin: 0;
    inset: 0;
    padding: 2px;
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: exclude;
    -webkit-mask-composite: destination-out;
    pointer-events: none;
    transition: background-position 0.3s ease;
  }

  .title {
    font-size: 12px;
    font-weight: bold;
  }

  .description {
    color: #fff;
    font-size: 14px;
  }

  ${(props) =>
    props.selected &&
    css`
      background: ${() => `${lighten(0.2, '#000')}`};

      .title,
      .description {
        color: #ffffff;
      }
    `}

    .kaizen-gradient-icon {
      svg {
        fill: url(#kaizen-gradient) !important;
      }
    } 
`

function JourneyResult({ item, selected, IconCmp, onItemClick, onSearchClose, ...rest }) {
  // "description" is the user's prompt
  const { name, description } = item;

  const handleClick = () => {
    handleJourneyAction(description, onSearchClose);
  };

  return (
    <JourneyResultContainer onClick={handleClick} {...rest} selected={selected}>
      <ResultMenuItemSingleRow>
        <Flex gridArea="icon" alignItems="center" justifyContent="center">
          {/* Define linear-gradient below to use as Kaizen Icon fill */}
          <svg width="0" height="0">
            <defs>
              <linearGradient id="kaizen-gradient" x1="100%" y1="100%">
                <stop stopColor="#b721ff" offset="25%" />
                <stop stopColor="#0072ff" offset="75%" />
                <stop stopColor="#00c6ff" offset="100%" />
              </linearGradient>
            </defs>
          </svg>
          {/* End linear-gradient definition */}

          <IconCmp iconSize={22} className="kaizen-gradient-icon" />
        </Flex>

        <Box gridArea="title">
          <Text className="title">{name}</Text>
        </Box>

        <Text
          className="description"
          gridArea="rightContent"
          muted
          small
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          style={{ overflow: 'hidden' }}
        >
          &quot;{description}&quot;
        </Text>
      </ResultMenuItemSingleRow>
    </JourneyResultContainer>
  );
}

export default observer(JourneyResult);
